import '@styles/app.css';
import header from '@commons/header';
import main from '@commons/main';

// Commons
header();
main();
